import LocationCreate from "./location-create";

export default LocationCreate;